module.exports = __webpack_public_path__ + "static/media/PH.0b8f6a00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PH.svg
// module id = 339
// module chunks = 0